import { FC, ReactNode } from 'react';

type Props = {
  /** Текст предложения */
  hint: string;
  /** Действия предложения */
  children: ReactNode;
};

/**
 * Строка предложения сохранить текущий вид таблицы пресетом: текст и действия.
 *
 * Предложение — строка раскладки рядом с таблицей, а не всплывающее окно у кнопки «Пресеты»: окно
 * ложилось поверх таблицы и её боковой панели и перехватывало клики, адресованные панели, —
 * плавающая панель закрывалась посреди настройки колонок.
 */
export const PresetOfferBar: FC<Props> = ({ hint, children }) => (
  <div role="status" className="flex flex-wrap items-center justify-end gap-x-3 gap-y-2 rounded-lg border px-3 py-2">
    <p className="flex-1 min-w-48 text-sm text-muted-foreground">{hint}</p>
    {/* Действия переносятся под текст целиком, а не по одному: пара читается как один выбор. */}
    <div className="flex flex-wrap items-center justify-end gap-2">{children}</div>
  </div>
);
